import React from 'react';
import {Box, Button, Menu, MenuItem, Tooltip, CircularProgress, useMediaQuery, useTheme} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';

interface ActiveProps {
    isAdmin: boolean;
    isSuperAdmin?: boolean;
    setActiveNavElem: React.Dispatch<React.SetStateAction<string>>;
    logout: (isError: boolean) => void;
    inn: string | null;
    balance: number | null;
}

const Header = (props: ActiveProps): React.JSX.Element => {
    const {isAdmin, isSuperAdmin, setActiveNavElem, logout, inn, balance} = props;
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down('sm'));

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        if (event.currentTarget.id === 'profile') {
            navigate('/profile');
            setActiveNavElem(' ');
        }
        if (event.currentTarget.id === 'exit') {
            logout(false);
        }
        setAnchorEl(null);
    };

    const handleClick = () => {
        if (isSuperAdmin) {
            setActiveNavElem('admin');
            navigate('/admin');
        } else if (isAdmin) {
            setActiveNavElem('deskControl');
            navigate('/kkm-control');
        } else {
            setActiveNavElem('home');
            navigate('/home');
        }
    };

    return (
        <header
            className="header"
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: isSm ? 'end' : 'space-between',
                flexWrap: 'wrap',
                gap: '1rem',
                padding: '0.5rem 1rem',
            }}
        >
            <Button
                onClick={handleClick}
                startIcon={<HomeOutlinedIcon />}
                sx={{
                    display: isSm ? 'none' : null,
                    textTransform: 'none',
                    color: '#fff',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    '&:active': {
                        backgroundColor: 'transparent',
                    },
                    borderRadius: '20px',
                    minHeight: '40px',
                }}
            >
                Главная
            </Button>

            <Box
                sx={{
                    width: isSm ? '100%' : 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: 'wrap',
                }}
            >
                {/*{isAdmin ? (*/}
                {/*    <Tooltip title="Пополнить баланс">*/}
                {/*        <Button*/}
                {/*            variant="contained"*/}
                {/*            onClick={() => navigate('/payment/paymenttowallet')}*/}
                {/*            startIcon={<AccountBalanceWalletOutlinedIcon />}*/}
                {/*            sx={{*/}
                {/*                textTransform: 'none',*/}
                {/*                borderRadius: '20px',*/}
                {/*                backgroundColor: '#fff',*/}
                {/*                color: '#333',*/}
                {/*                '&:hover': {*/}
                {/*                    backgroundColor: '#f0f0f0',*/}
                {/*                },*/}
                {/*                height: '40px',*/}
                {/*                px: 2,*/}
                {/*                display: 'flex',*/}
                {/*                alignItems: 'center',*/}
                {/*                justifyContent: 'center',*/}
                {/*            }}*/}
                {/*        >*/}
                {/*            {balance === null ? <CircularProgress size={20} thickness={4} sx={{color: '#ccc'}} /> : <span>{balance} ₸</span>}*/}
                {/*        </Button>*/}
                {/*    </Tooltip>*/}
                {/*) : (*/}
                {/*    <></>*/}
                {/*)}*/}

                <Button
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenu}
                    variant="contained"
                    startIcon={<AccountCircleOutlinedIcon />}
                    endIcon={<ArrowDropDownIcon />}
                    sx={{
                        width: isSm ? '100%' : 'auto',
                        textTransform: 'none',
                        borderRadius: '20px',
                        backgroundColor: '#fff',
                        color: '#333',
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                        height: '40px',
                    }}
                >
                    {inn}
                </Button>

                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    TransitionProps={{
                        timeout: 200,
                    }}
                >
                    {!isAdmin && (
                        <MenuItem id="profile" onClick={handleClose}>
                            Профиль
                        </MenuItem>
                    )}
                    <MenuItem id="exit" onClick={handleClose}>
                        Выход
                    </MenuItem>
                </Menu>
            </Box>
        </header>
    );
};

export default Header;
